import Hero from '../components/Hero';
import Services from '../components/Services';
import CategoryGrid from '../components/CategoryGrid';
import Licensed from '../components/Licensed';
import ImmediateService from '../components/ImmediateService';
import Reviews from '../components/Reviews';
import FAQ from '../components/FAQ';

export default function HomePage() {
  return (
    <>
      <Hero />
      <Services />
      <CategoryGrid />
      <Licensed />
      <ImmediateService />
      <Reviews />
      <FAQ />
    </>
  );
}
